import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getDataPeserta = 'data-peserta-pelatihan';
const detailDataPeserta = 'data-peserta-pelatihan/';
const getSertifikat = 'data-peserta-pelatihan-webinar/pengaturan-sertifikat/';
const getPelatihan = 'workshop-pelatihan';
const downloadSKP = 'data-peserta-pelatihan-export';
const putSertifikat = 'data-peserta-pelatihan/upload-sertifikat/';
const getDataDokumen = 'data-peserta-pelatihan/dokumen-pendukung-peserta-pelatihan/';
const ProsesAdministrasiUrl = 'data-peserta-pelatihan/proses-administrasi/';
const putStatusPembatalan = 'data-peserta-pelatihan/ubah-status-pembatalan/';

class DataPesertaService {
    getDataPeserta(
        currentPage,
        pageSize,
        idWorkshopPelatihan,
        filter
    ) {
        var data = {
            pageNo: currentPage,
            pageSize: pageSize,
            idWorkshopPelatihan: idWorkshopPelatihan,
            status_pembayaran: "umum",
            filter: filter
        }
        return axios.get(
            API_URL + getDataPeserta,
            {
                params: data,
                headers: authHeader()
            });
    }

    getPelatihan() {
        return axios.get(
            API_URL + getPelatihan, {
            headers: authHeader()
        });

    }

    getSertifikat(id_pelatihan_peserta) {
        return axios.get(
            API_URL + getSertifikat + id_pelatihan_peserta, {
            headers: authHeader()
        });

    }

    detailDataPeserta(idPelatihanPeserta) {
        return axios
            .get(
                API_URL + detailDataPeserta + idPelatihanPeserta,
                { headers: authHeader() }
            );
    }
    
    downloadSKP(pelatihan, periode) {
        return axios.get(
            API_URL + downloadSKP + '?idWorkshopPelatihan=' + pelatihan + '&periode=' + periode,
            {
                headers: authHeader(),
                responseType: 'blob'
            });
    }

    putSertifikat(formData) {
        var headers = authHeader(); 
        var form = new FormData();
        form.append('statusPenerimaan', formData.status_penerimaan);

        if (typeof formData.file !== 'undefined') {
            form.append('file', formData.file);
        }
        return axios
        .put(
            API_URL + putSertifikat + formData.id_pelatihan_peserta, form,
            { headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() }  }
        );
    }
    
    getDataDokumen(idPelatihanPeserta) {
        return axios
            .get(
                API_URL + getDataDokumen + idPelatihanPeserta,
                { headers: authHeader() }
            );
    }

    putSendProsesAdministrasi(formProsesAdministrasi) {
        var headers = authHeader();

        return axios
        .put(
            API_URL + ProsesAdministrasiUrl + formProsesAdministrasi.idPelatihanPeserta,
            formProsesAdministrasi,
            { headers: { 'Content-Type': 'application/json','Authorization' : tokenHeader() } }
        );
    }

    putStatusPembatalan(formData) {        
        return axios.put(API_URL + putStatusPembatalan + formData.idPelatihanPeserta, 
            formData,
        {
            headers: authHeader() 
        });
    }

}

export default new DataPesertaService();